import { mutator } from 'satcheljs';
import getStore from '../store/store';
import setGetServicesState from '../actions/setGetServicesState';

/**
 * Updates the current services getting status in the store.
 */
export default mutator(setGetServicesState, actionMessage => {
    let store = getStore();
    store.getServicesRequestStatus = actionMessage.getServicesRequestStatus;
});
